import { CreateService } from '@/services/service';
import { GiftEntity } from '@/entities/gift.entity';

export default class GiftService extends CreateService<GiftEntity>('gift') {
  async updateOne(
    id: number,
    instance: Partial<GiftEntity>,
  ): Promise<GiftEntity> {
    const { data } = await this.apiBuilder.updateOne(id, instance);
    return data;
  }
}
